import { RouterModule } from '@angular/router';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { Observable, filter, pipe } from 'rxjs';
import * as SettingSelectors from '@roi/common/stored/global/selector/setting.selector';
import { Store, select } from '@ngrx/store';
import {
  sidebar_type,
  update_setting,
} from '@roi/common/stored/global/actions/setting.action';
import { NgRxState } from '@roi/common/stored/global';

@Component({
  imports: [RouterModule],
  selector: 'hui-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  sidebarTypeSelector$: Observable<any>;
  sidebarValue: any = [];
  private ngrxStore = inject(Store<NgRxState>);
  constructor() {
    this.ngrxStore.dispatch(update_setting());
    this.sidebarTypeSelector$ = this.ngrxStore.pipe(
      select(SettingSelectors.sidebarTypeSelector)
    );
    this.sidebarTypeSelector$.subscribe((value) => (this.sidebarValue = value));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const sidebarResponsive = document.querySelector(
      '[data-sidebar="responsive"]'
    );
    if (event.target.innerWidth < 1199) {
      this.ngrxStore.dispatch(
        sidebar_type({ value: [...this.sidebarValue, 'sidebar-mini'] })
      );
    } else {
      this.ngrxStore.dispatch(
        sidebar_type({
          value: this.sidebarValue.filter((x: string) => x != 'sidebar-mini'),
        })
      );
    }
  }
  ngOnInit(): void {}
}
